// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2uoeX","errorLogs":"styles_errorLogs__11uLW"};